export enum transactionType {
  payment = "payment",
  topUp = "topUp",

  // dummy types: TODO : delete later
  order = "order",
  subscription = "subscription",
  payOut = "payOut",
}
